import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

// [جدید] تزریق Keyframes برای انیمیشن پالس
// از آنجایی که از Tailwind استفاده نمی‌کنیم، این تنها راه افزودن keyframes است
const PulseKeyframes = () => (
  <style>
    {`
      @keyframes pulse-green {
        0%, 100% { box-shadow: 0 0 0 0px rgba(74, 222, 128, 0.7); } /* green-400 */
        50% { box-shadow: 0 0 0 4px rgba(74, 222, 128, 0); }
      }
      @keyframes pulse-red {
        0%, 100% { box-shadow: 0 0 0 0px rgba(248, 113, 113, 0.7); } /* red-400 */
        50% { box-shadow: 0 0 0 4px rgba(248, 113, 113, 0); }
      }
      @keyframes pulse-gray {
        0%, 100% { box-shadow: 0 0 0 0px rgba(156, 163, 175, 0.5); } /* gray-400 */
        50% { box-shadow: 0 0 0 4px rgba(156, 163, 175, 0); }
      }
      
      /* [جدید] انیمیشن‌های اضافه شده بر اساس قوانین جدید */
      @keyframes pulse-pink {
        0%, 100% { box-shadow: 0 0 0 0px rgba(244, 114, 182, 0.7); } /* pink-400 */
        50% { box-shadow: 0 0 0 4px rgba(244, 114, 182, 0); }
      }
      @keyframes pulse-blue {
        0%, 100% { box-shadow: 0 0 0 0px rgba(96, 165, 250, 0.7); } /* blue-400 */
        50% { box-shadow: 0 0 0 4px rgba(96, 165, 250, 0); }
      }
      @keyframes pulse-orange {
        0%, 100% { box-shadow: 0 0 0 0px rgba(251, 146, 60, 0.7); } /* orange-400 */
        50% { box-shadow: 0 0 0 4px rgba(251, 146, 60, 0); }
      }
    `}
  </style>
);


// --- هوک Debounce (بدون تغییر) ---
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

// --- کامپوننت اصلی صفحه (بازنویسی شده با استایل درون‌خطی) ---
const DeviceListPage = ({ onLogout }) => {
  const [devices, setDevices] = useState([]);
  const [deviceStatuses, setDeviceStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [isDarkMode, setIsDarkMode] = useState(true);

  // [جدید] تابع واکشی وضعیت‌ها در useCallback پیچیده شد
  const fetchDeviceStatuses = useCallback(async (deviceList, token) => {
    try {
      const deviceIds = deviceList.map(d => d.id);
      
      const response = await fetch(`https://sguardapi.tabangohar.com/api/get_device_statuses.php`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ device_ids: deviceIds })
      });

      if (!response.ok) throw new Error('خطا در دریافت وضعیت‌ها');
      const data = await response.json();
      if (data.status === 'success') {
        setDeviceStatuses(data.data);
      }
    } catch (err) {
      console.error(err.message);
    }
  }, []); // این تابع وابستگی ندارد

  // تابع واکشی دستگاه‌ها (API اول)
  const fetchDevices = useCallback(async () => {
    setLoading(true);
    setError(null);
    setDevices([]); 
    setDeviceStatuses({}); 
    const token = localStorage.getItem('token');

    try {
      const params = new URLSearchParams({
        page,
        limit: 50,
        search: debouncedSearchTerm,
        sort: 'd.id',
        dir: 'desc',
      });

      const response = await fetch(`https://sguardapi.tabangohar.com/api/get_devices.php?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        if (response.status === 401) onLogout();
        throw new Error(`خطا در دریافت دستگاه‌ها: ${response.statusText}`);
      }

      const data = await response.json();

      if (data.status === 'success') {
        setDevices(data.data);
        setTotalPages(data.totalPages);
        if (data.data.length > 0) {
          fetchDeviceStatuses(data.data, token);
        }
      } else {
        throw new Error(data.message || 'خطا در API دستگاه‌ها');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [page, debouncedSearchTerm, onLogout, fetchDeviceStatuses]);

  
  useEffect(() => {
    fetchDevices();
  }, [fetchDevices]);

  // [جدید] رفرش 30 ثانیه‌ای وضعیت‌ها
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    // این interval هر 30 ثانیه فقط وضعیت‌ها را رفرش می‌کند
    const intervalId = setInterval(() => {
      if (devices.length > 0) {
        fetchDeviceStatuses(devices, token);
      }
    }, 30000); // 30 ثانیه

    return () => clearInterval(intervalId); // پاکسازی در زمان unmount
  }, [devices, fetchDeviceStatuses]); // وابستگی به devices تا لیست درستی را رفرش کند

  useEffect(() => {
    setPage(1);
  }, [debouncedSearchTerm]);


  // استایل‌های پویا برای صفحه
  const pageStyles = useMemo(() => ({
    page: {
      padding: '32px',
      width: '80%', // [تغییر کرد] عرض ثابت 80% به جای حداکثر عرض
      margin: '0 auto', // مرکز چین کردن صفحه
      textAlign: 'right',
      direction: 'rtl',
      minHeight: '100vh',
      position: 'relative',
      backgroundColor: isDarkMode ? '#111827' : '#f3f4f6',
      color: isDarkMode ? '#ffffff' : '#1f2937',
      transition: 'background-color 0.3s ease',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '24px',
      flexWrap: 'wrap',
    },
    title: {
      fontSize: '2rem',
      fontWeight: 'bold',
      color: isDarkMode ? '#ffffff' : '#111827',
      margin: '0 0 16px 0',
    },
    logoutButton: {
      backgroundColor: '#dc2626',
      color: 'white',
      padding: '8px 16px',
      borderRadius: '6px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
    },
    searchInput: {
      padding: '8px',
      borderRadius: '6px',
      border: `1px solid ${isDarkMode ? '#4b5563' : '#d1d5db'}`,
      backgroundColor: isDarkMode ? '#374151' : '#ffffff',
      color: isDarkMode ? '#ffffff' : '#1f2937',
      outline: 'none',
      marginBottom: '16px',
      width: '33.33%',
      minWidth: '280px',
    },
    deviceGrid: {
      display: 'flex',
      flexDirection: 'row-reverse',
      flexWrap: 'wrap',
      gap: '16px',
      justifyContent: 'flex-end',
    },
    messageText: {
      textAlign: 'center',
      padding: '20px',
      color: isDarkMode ? '#d1d5db' : '#4b5563',
    },
    toggleButton: {
      position: 'absolute',
      top: '24px',
      left: '24px',
      background: isDarkMode ? '#4b5563' : '#e5e7eb',
      color: isDarkMode ? '#fde047' : '#f59e0b',
      border: 'none',
      borderRadius: '50%',
      width: '40px',
      height: '40px',
      cursor: 'pointer',
      fontSize: '18px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10,
    }
  }), [isDarkMode]);

  return (
    <div style={pageStyles.page}>
      <PulseKeyframes /> {/* [جدید] تزریق انیمیشن‌ها */}
      <button
        style={pageStyles.toggleButton}
        onClick={() => setIsDarkMode(!isDarkMode)}
      >
        {isDarkMode ? '☀️' : '🌙'}
      </button>

      <div style={pageStyles.header}>
        <h1 style={pageStyles.title}>مانیتورینگ دستگاه‌ها</h1>
        <button
          onClick={onLogout}
          style={pageStyles.logoutButton}
        >
          خروج
        </button>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <input
          type="text"
          placeholder="جستجو در سیم 1، شماره سرویس یا نام مالک..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={pageStyles.searchInput}
        />
      </div>

      {loading && <p style={pageStyles.messageText}>در حال بارگذاری دستگاه‌ها...</p>}
      {error && <p style={{...pageStyles.messageText, color: '#ef4444'}}>{error}</p>}
      {!loading && !error && devices.length === 0 && (
         <p style={pageStyles.messageText}>هیچ دستگاهی یافت نشد.</p>
      )}

      {!loading && devices.length > 0 && (
        <div style={pageStyles.deviceGrid}>
          {devices.map((device) => (
            <DeviceCard 
              key={device.id} 
              device={device} 
              status={deviceStatuses[device.id]} 
              isDarkMode={isDarkMode}
            />
          ))}
        </div>
      )}

      {!loading && totalPages > 1 && (
         <Pagination page={page} totalPages={totalPages} onPageChange={setPage} isDarkMode={isDarkMode} />
      )}
    </div>
  );
};

// --- کامپوننت کارت دستگاه (تغییر محتوا + انیمیشن) ---
const DeviceCard = ({ device, status, isDarkMode }) => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  // [تغییر کرد] منطق تعیین رنگ بر اساس قوانین جدید شما
  const getStatusColorStyles = () => {
    // پیش‌فرض: خاکستری (زمانی که status وجود ندارد)
    let colors = {
      backgroundColor: isDarkMode ? '#374151' : '#e5e7eb',
      borderColor: isDarkMode ? '#4b5563' : '#d1d5db',
      color: isDarkMode ? '#ffffff' : '#1f2937',
      dotColor: isDarkMode ? '#9ca3af' : '#6b7280',
      dotHighlight: isDarkMode ? '#6ee7b7' : '#10b981', // رنگ متن سبز در حالت هاور
      dotDim: isDarkMode ? '#f87171' : '#ef4444',       // رنگ متن قرمز در حالت هاور
      hoverBg: isDarkMode ? '#4b5563' : '#d1d5db',
      animationName: 'pulse-gray',
    };

    if (!status) return colors; // اگر دستگاه گزارشی نداشته باشد، خاکستری بمان

    const { statusOK, armed, calendar, detect } = status;

    // قانون ۱: صورتی
    // 0 * * * = pink
    if (statusOK === 0) {
      colors.backgroundColor = isDarkMode ? '#831843' : '#fce7f3'; // pink-800 / pink-50
      colors.borderColor = isDarkMode ? '#be185d' : '#f472b6';     // pink-600 / pink-300
      colors.dotColor = isDarkMode ? '#f472b6' : '#db2777';       // pink-400 / pink-600
      colors.hoverBg = isDarkMode ? '#9d174d' : '#fbcfe8';      // pink-700 / pink-100
      colors.animationName = 'pulse-pink';
    } 
    // سایر قوانین (statusOK = 1)
    else {
      // اگر armed = 1
      if (armed === 1) {
        // قانون ۳: قرمز
        // 1 1 * 1 = red
        if (detect === 1) {
          colors.backgroundColor = isDarkMode ? '#7f1d1d' : '#fee2e2'; // red-800 / red-100
          colors.borderColor = isDarkMode ? '#b91c1c' : '#f87171';     // red-600 / red-400
          colors.dotColor = isDarkMode ? '#fca5a5' : '#ef4444';       // red-300 / red-500
          colors.hoverBg = isDarkMode ? '#991b1b' : '#fecaca';      // red-700 / red-200
          colors.animationName = 'pulse-red';
        } 
        // قانون ۲: سبز
        // 1 1 * 0 = green
        else { // (detect === 0)
          colors.backgroundColor = isDarkMode ? '#166534' : '#dcfce7'; // green-800 / green-100
          colors.borderColor = isDarkMode ? '#15803d' : '#86efac';     // green-600 / green-300
          colors.dotColor = isDarkMode ? '#6ee7b7' : '#22c55e';       // green-300 / green-500
          colors.hoverBg = isDarkMode ? '#14532d' : '#bbf7d0';      // green-700 / green-200
          colors.animationName = 'pulse-green';
        }
      } 
      // اگر armed = 0
      else {
        // قانون ۵: زرد/نارنجی
        // 1 0 1 * = Yellow/orangish
        if (calendar === 1) {
          colors.backgroundColor = isDarkMode ? '#7c2d12' : '#fff7ed'; // orange-800 / orange-50
          colors.borderColor = isDarkMode ? '#c2410c' : '#fb923c';     // orange-600 / orange-300
          colors.dotColor = isDarkMode ? '#fb923c' : '#f97316';       // orange-400 / orange-500
          colors.hoverBg = isDarkMode ? '#9a3412' : '#fed7aa';      // orange-700 / orange-200
          colors.animationName = 'pulse-orange';
        } 
        // قانون ۴: آبی
        // 1 0 0 * = blue
        else { // (calendar === 0)
          colors.backgroundColor = isDarkMode ? '#1e3a8a' : '#dbeafe'; // blue-800 / blue-100
          colors.borderColor = isDarkMode ? '#1d4ed8' : '#60a5fa';     // blue-600 / blue-300
          colors.dotColor = isDarkMode ? '#60a5fa' : '#2563eb';       // blue-400 / blue-500
          colors.hoverBg = isDarkMode ? '#1e40af' : '#bfdbfe';      // blue-700 / blue-200
          colors.animationName = 'pulse-blue';
        }
      }
    }
    
    return colors;
  };

  const colors = getStatusColorStyles();

  // استایل‌های پویا برای کارت
  const cardStyles = {
    base: {
      width: '100px', // [جدید] سایز کوچک‌تر
      height: '100px', // [جدید] سایز کوچک‌تر
      borderRadius: '8px',
      border: `1px solid ${colors.borderColor}`,
      backgroundColor: colors.backgroundColor,
      color: colors.color,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '8px',
      position: 'relative',
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease, border-color 0.3s ease',
      // [جدید] اعمال انیمیشن پالس
      animation: `${colors.animationName} 2s infinite`,
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)', // سایه ملایم
    },
    hover: {
      backgroundColor: colors.hoverBg,
      animation: 'none', // [جدید] توقف انیمیشن در حالت هاور
    },
    normalView: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      transition: 'opacity 0.3s ease',
      opacity: isHovered ? 0 : 1,
      position: 'absolute',
      padding: '8px',
      width: '100%',
    },
    hoverView: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      textAlign: 'right',
      fontSize: '10px', // [جدید] فونت کوچک‌تر
      transition: 'opacity 0.3s ease',
      opacity: isHovered ? 1 : 0,
      position: 'absolute',
      padding: '8px',
    },
    statusDot: {
      width: '12px', // [جدید] کوچک‌تر
      height: '12px', // [جدید] کوچک‌تر
      borderRadius: '50%',
      backgroundColor: colors.dotColor,
      marginBottom: '4px', // [جدید] فاصله کمتر
      border: `1px solid ${colors.borderColor}`,
    },
    deviceId: { // [تغییر کرد] این استایل دیگر در نمای عادی استفاده نمی‌شود
      fontWeight: 'bold',
      fontSize: '18px',
    },
    ownerName: { // [تغییر کرد] این استایل اصلی نمای عادی است
      fontSize: '12px', // کمی بزرگتر
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      marginBottom: '4px', // فاصله
    },
    // [جدید] استایل برای سیم‌کارت در حالت عادی
    simNumber: {
      fontSize: '10px', // [تغییر کرد] کمی بزرگتر
      color: isDarkMode ? '#9ca3af' : '#4b5563',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
    },
    booleanStatus: {
      borderTop: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'}`,
      paddingTop: '4px',
      display: 'flex',
      justifyContent: 'space-around',
      fontSize: '9px', // [جدید] کوچک‌تر
      gap: '2px',
    },
    editButton: {
      width: '100%',
      textAlign: 'center',
      fontSize: '10px',
      padding: '2px 0',
      borderRadius: '4px',
      backgroundColor: isDarkMode ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.1)',
      border: 'none',
      color: 'inherit',
      cursor: 'pointer',
      marginTop: '4px',
    }
  };

  return (
    <div 
      style={{ ...cardStyles.base, ...(isHovered ? cardStyles.hover : {}) }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => navigate(`/edit/${device.id}`)}
    >
      {/* --- [تغییر کرد] حالت عادی (بدون هاور) --- */}
      <div style={cardStyles.normalView}>
        <span style={cardStyles.statusDot}></span>
        {/* [تغییر کرد] نمایش نام مالک */}
        <span style={cardStyles.ownerName} title={device.owner_name || 'بدون مالک'}>
          {device.owner_name || 'بدون مالک'}
        </span>
        {/* [تغییر کرد] نمایش شماره سیم 1 */}
        <span style={cardStyles.simNumber} title={device.device_sim1}>
          {device.device_sim1 || 'بدون سیم'}
        </span>
      </div>
      
      {/* --- [تغییر کرد] حالت هاور (اطلاعات تکمیلی) --- */}
      <div style={cardStyles.hoverView}>
        {/* [جدید] ID در هاور هم نمایش داده می‌شود */}
        <p style={{fontWeight: 'bold', fontSize: '12px'}}>ID: {device.id}</p>
        <p><strong>انقضا:</strong> {formatDate(device.due_date)}</p>
        
        {status && (
          <div style={cardStyles.booleanStatus}>
            <span style={{ color: status.statusOK ? colors.dotHighlight : colors.dotDim }}>OK</span>
            <span>|</span>
            <span style={{ color: status.armed ? colors.dotHighlight : colors.dotDim }}>ARM</span>
            <span>|</span>
            <span style={{ color: status.calendar ? colors.dotHighlight : colors.dotDim }}>CAL</span>
            <span>|</span>
            <span style={{ color: status.detect ? colors.dotHighlight : colors.dotDim }}>DET</span>
          </div>
        )}

        <button style={cardStyles.editButton}>
          ویرایش
        </button>
      </div>
    </div>
  );
};


// --- کامپوننت صفحه‌بندی (با استایل درون‌خطی) ---
const Pagination = ({ page, totalPages, onPageChange, isDarkMode }) => {
  if (totalPages <= 1) return null;
  
  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '24px',
      gap: '8px',
      direction: 'ltr',
    },
    button: {
      padding: '8px 16px',
      borderRadius: '6px',
      border: `1px solid ${isDarkMode ? '#4b5563' : '#d1d5db'}`,
      backgroundColor: isDarkMode ? '#374151' : '#ffffff',
      color: isDarkMode ? '#ffffff' : '#1f2937',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
    },
    buttonDisabled: {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
    text: {
      color: isDarkMode ? '#d1d5db' : '#4b5563',
      margin: '0 8px',
    }
  };

  return (
    <div style={styles.container}>
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
        style={{...styles.button, ...(page <= 1 ? styles.buttonDisabled : {})}}
      >
        قبلی
      </button>
      <span style={styles.text}>
        صفحه {page} از {totalPages}
      </span>
      <button
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
        style={{...styles.button, ...(page >= totalPages ? styles.buttonDisabled : {})}}
      >
        بعدی
      </button>
    </div>
  );
};

// --- تابع فرمت تاریخ (بدون تغییر) ---
const formatDate = (dateString) => {
  if (!dateString) return '-';
  try {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Intl.DateTimeFormat('fa-IR', options).format(new Date(dateString));
  } catch (e) {
    return dateString;
  }
};

export default DeviceListPage;